import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Plus: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'plus'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M11 11.0001V5.00012H13V11.0001H19V13.0001H13V19.0001H11V13.0001H5V11.0001H11Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Plus
